import {createRouter} from 'vue-router';

const routes = [
	{
		path: '/',
		name: 'Home',
		component: () => import('../views/home'),
		meta: {
			title: 'Зота Системс — разработка сайтов и веб-приложений',
			description: 'Разрабатываем интернет-магазины, корпоративные сайты и веб-приложения для бизнеса. Интегрируем сайты с 1С.'
		}
	},
	{
		path: '/projects',
		name: 'Projects',
		component: () => import('../views/projects/index'),
		meta: {
			title: 'Проекты Зота Системс — сайты и веб-приложения',
			description: 'Кейсы Зота Системс: интернет-магазины, корпоративные сайты и веб-приложения, созданные для бизнеса.'
		}
	},
	{
		path: '/projects/:id',
		name: 'ProjectsId',
		component: () => import('../views/project_id/index'),
		meta: {
			title: 'Проект Зота Системс — кейс веб-разработки',
			description: 'Кейс Зота Системс: задачи проекта, разработанное решение, дизайн и результат.'
		}
	},
	{
		path: '/politic',
		name: 'Politic',
		component: () => import('../views/Politic'),
		meta: {
			title: 'Политика конфиденциальности — Зота Системс',
			description: 'Политика обработки и защиты персональных данных пользователей сайта Зота Системс.'
		}
	},
	{
		path: '/legal-info',
		name: 'LegalInfo',
		component: () => import('../views/LegalInfo'),
		meta: {
			title: 'Юридическая информация — Зота Системс',
			description: 'Юридическая информация и реквизиты веб-студии Зота Системс.'
		}
	},
	{
		path: '/:pathMatch(.*)*',
		name: 'not-found',
		component: () => import('../views/NotFound'),
		meta: {
			title: 'Страница не найдена — Зота Системс',
			description: 'Запрашиваемая страница не найдена. Перейдите на главную страницу сайта Зота Системс.'
		}
	}
];

export default function (history) {
    const router = createRouter({
        history,
        routes,
        scrollBehavior(to, from, savedPosition) {
            if (savedPosition) {
                return savedPosition;
            } else if (to.hash) {
                const options = {
                    top: document.querySelector(to.hash).offsetTop,
                    behavior: 'smooth'
                };
                window.scrollTo(options);

            } else {
                window.scrollTo(0, 0);
            }
        }
    })

	router.afterEach((to) => {
		if (typeof document === 'undefined') return

		document.title = to.meta.title || 'Зота Системс'

		const description = document.querySelector('meta[name="description"]')
		if (description) {
			description.setAttribute('content', to.meta.description || '')
		}
	})

	return router
}
